


@if (initialized && interactionData && interactionData.interaction) {

<div class="flex flex-column align-items-center gap-3 mt-8">
  <span class="text-900 text-lg text-center">
    {{interactionData.interaction.typeDto.euSuccessMessage}}
  </span>

  <img class="w-20rem" src="{{interactionData.interaction.typeDto.euSuccessImageUrl}}">

  @if (interactionData.interaction.ticketId) {
  <span class="text-center">
    Wir bearbeiten dein Anliegen unter der Ticketnummer <b class="text-primary">{{interactionData.interaction.ticketId}}</b>
    </span>
  }

  <p-button label="Zurück zum Dashboard" class="mt-5" [routerLink]="['/ds/home']"></p-button>

</div>



}
